import * as Yup from "yup";

export const schema = Yup.object().shape({
  email: Yup.string(),
  status: Yup.array().nullable(),
  currency: Yup.array().nullable(),
  plan: Yup.array().nullable(),
});

interface FormValues {
  email: string;
  status: string[];
  currency: string[];
  plan: string[];
}

export const initialValues: FormValues = {
  email: "",
  status: [],
  currency: [],
  plan: []
};
